import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { RoleService } from '../../../services/core/role/role.service';
import { sweetAlert } from 'src/app/utils/swal';
import { noWhitespaceValidator } from 'src/app/utils/network-utils';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
@UntilDestroy()

@Component({
  selector: 'app-add-role',
  templateUrl: './add-role.component.html',
  styleUrls: ['./add-role.component.css']
})
export class AddRoleComponent implements OnInit {
  roleForm!:FormGroup;
  submitted = false;
  roleId:any;
  servicesList:any =[];
  selectedPermission:any=[];
  permissionsList:any = [];
  types: any = [];

  @Input() roles:any;
  @Input() source:any;
  @Output() onSaveRole = new EventEmitter<string>();
  @Output() onCloseModal = new EventEmitter<string>();



  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private roleService: RoleService,
  ) { }
  ngOnInit(): void {

    this.roleForm = this.fb.group({
      name: ['', Validators.required],
      type: ['company', Validators.required],
      description: ['', [Validators.required, noWhitespaceValidator()]],
      permissions: [[], Validators.required],
      isActive: [true],
    });

     if (this.source === 'modal' && this.roles) {
      this.roleId = this.roles.id;
       this.getroleById();
    } 
    this.getAllPermissions()
    this.getAllTypes();
  }

  onSave() {
     this.submitted = true;
    if (this.roleForm.invalid){
      return;
    } 
     let payload = this.roleForm.getRawValue();
    if (payload.name) {
      payload.name = payload.name.toLowerCase();
    }
     this.roleService.saveUser(this.roleId, payload).pipe(untilDestroyed(this)).subscribe(
       (data: any) => {
         if (data) {
          //  this.router.navigateByUrl(`/roles`);
          if (this.source === 'modal') {
            this.onSaveRole.emit(data);
          } else {
            this.router.navigateByUrl('/roles');
          }
         }
       },
       (err) => {
         sweetAlert("Error", err, "error", "OK");
       }
     );
   }

  getAllPermissions() {
    this.roleService.getPermission().pipe(untilDestroyed(this)).subscribe(
      (data: any) => {
        if (data) {
          this.permissionsList = data || [];;
        }
      },
      (err) => {
        const errorMessage = err || 'An unexpected error occurred.';
        sweetAlert('Error', errorMessage, 'warning', 'OK');
      }

    );
  }

    getAllTypes() {
    this.roleService.getTypes().pipe(untilDestroyed(this)).subscribe(
      (data: any) => {
        if (data) {
          this.types = data;
        }
      },
      (err) => {
        const errorMessage = err || 'An unexpected error occurred.';
        sweetAlert('Error', errorMessage, 'warning', 'OK');
      }

    );
  }

  getroleById(){
   this.roleService.getRoleById(this.roleId).pipe(untilDestroyed(this)).subscribe((data:any)=>{
     if (data) {
       this.roleForm.patchValue({
         ...data,
         
       })
       this.selectedPermission = data.permissions
       this.roleForm.get('type')?.disable();
     }
   })
  }
  onSelectPermission(){
    this.roleForm.patchValue({
      permissions: this.selectedPermission
    });
  }

  toggleSelectAll(event: any) {
  const checked = event.target.checked;
  if (checked) {
    this.selectedPermission = [...this.permissionsList];
  } else {
    this.selectedPermission = [];
  }
}

 isAllSelected(): boolean {
  return this.selectedPermission.length === this.permissionsList.length;
}



  get form() {
    return this.roleForm.controls;
  }
}

